import React, { Component } from 'react'

import style from './style.module.css'

export default class Button extends Component {
    render() {
        const { children, className, primary, spacing, secondary, inline, ...props } = this.props

        const classes = [style.btn]

        if(primary)
        classes.push(style.primary)

        if(secondary)
        classes.push(style.secondary)

        if(inline)
        classes.push(style.inline)

        if(className)
        classes.push(className)

        if(spacing)
        classes.push(style[`spacing-${spacing}`])

        return (
            <button className={classes.join(' ')} { ...props }>
                {children}
            </button>
        )
    }
}


// WEBPACK FOOTER //
// ./src/v2SPRINTA/atoms/Button/index.js